import { FC } from "react";
import { Routes, Route } from "react-router-dom";

import FlashToken from "../pages/Flashtoken";
import PressPage from "../pages/Press";

const Navigation: FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<FlashToken />} />
        <Route path="/press" element={<PressPage />} />
      </Routes>
    </>
  );
};

export default Navigation;
